export default "__VITE_ASSET__78624f60__"